import React, { useEffect, useRef, useState } from "react";
import { Button, Dropdown, Field, Option } from "@fluentui/react-components";
import { useTaskPane } from "../../provider/TaskPaneProvider";
import { handleKeyNumberPress } from "../../../utils/formats";

const TaskForm = ({ updateState }) => {
  const inputRef = useRef(null);
  const inputRefDue = useRef(null);
  const [startDaysToAdd, setStartDaysToAdd] = useState(null);
  const [dueDaysToAdd, setDueDaysToAdd] = useState(null);
  const { queues, userGroups, user, taskPaneState, taskTypes, priorityList } = useTaskPane();
  const addDays = (dateStr, days) => {
    const date = new Date(dateStr);
    date.setDate(date.getDate() + parseInt(days || 0));
    return date.toISOString().split("T")[0];
  };

  const handleApplyDays = () => {
    if (startDaysToAdd) {
      const newDate = addDays(taskPaneState.taskStartDate? taskPaneState.taskStartDate: new Date(), startDaysToAdd);
      updateState("taskStartDate", newDate);
    }
    if (dueDaysToAdd) {
      const newDate = addDays(taskPaneState.taskDueDate? taskPaneState.taskDueDate : new Date(), dueDaysToAdd);
      updateState("taskDueDate", newDate);
    }
    if(inputRef?.current) inputRef.current.value = null;
    if(inputRef?.current) inputRefDue.current.value = null;
    setStartDaysToAdd(null);
    setDueDaysToAdd(null);
  };

  useEffect(() => {
    if (taskPaneState.sameAsDocDesc) {
      updateState("taskSubject", taskPaneState?.docDescription || "");
    } else updateState("taskSubject", "");

  }, [taskPaneState.sameAsDocDesc])

  return (
    <>
      {/* Subject Row */}
      <div className="text-left block text-gray-600 text-sm font-medium mb-1">
        <label className="h3-text text-sm text-gray-700 flex items-center">
          <input
            type="checkbox"
            checked={taskPaneState.taskChecked}
            onChange={(e) => updateState("taskChecked", e.target.checked)}
            className="mr-2"
          />
          Task
        </label>  
      </div>
        {taskPaneState.taskChecked && <>
      <div className="grid grid-cols-1 sm:grid-cols-3 lg:grid-cols-3 gap-1 sm:mt-0 lg:mt-0 mt-3">
            <div className="col-span-2 flex flex-row items-center">
          <label  style={{ minWidth: '8rem' }} className="h3-text text-left block text-gray-600 text-xs sm:text-sm lg:text-base font-medium mb-1 w-30">Subject</label>
        <Field className="col-span-2 items-center gap-1 w-full">
          <input
            type="text"
            disabled={taskPaneState?.sameAsDocDesc}
            value={taskPaneState.taskSubject}
            onChange={(e) => updateState("taskSubject", e.target.value)}
            placeholder="Enter subject"
            className="input-layout rounded py-1 px-2 text-xs sm:text-sm lg:text-base text-gray-700 w-full"
          />
        </Field>
        </div>
        <div className="mt-0 flex flex-row items-center">
          <label className="h3-text text-gray-600 flex items-center mt-2 sm:mt-0 space-x-2">
            <input
              disabled={!taskPaneState?.taskChecked}
              type="checkbox"
              checked={taskPaneState.sameAsDocDesc}
              onChange={(e) => updateState("sameAsDocDesc", e.target.checked)}
              className="mr-2"
            />
            <span className="h3-text">  Same as Doc Desc</span>
          </label>
        </div>

      </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-2 gap-1 mt-1">

          <div className="grid grid-cols-1 sm:mt-0 lg:mt-0 mt-3 sm:grid-cols-1 lg:grid-cols-1 gap-1">
               <div className="flex w-full flex-row items-center">
          <label style={{ minWidth: '8rem' }} className="h3-text text-left block text-gray-600 text-xs sm:text-sm lg:text-base font-medium mb-1 w-30">User Group</label>
            <Field className="items-center  gap-1 w-full">
              <Dropdown
                aria-label="User Group"
                size="small"
                positioning={{ autoSize: false }}
                listbox={{ style: { maxHeight: "min(18rem, 60vh)", overflowY: "auto" } }}
                style={{ minWidth: 0, width: "100%" }}
                disabled={!taskPaneState?.taskChecked || !userGroups.length}
                value={userGroups?.find((item) => String(item.userGroupID) === String(taskPaneState.userGroupId))?.description || "Select"}
                selectedOptions={[String(taskPaneState.userGroupId ?? "")]}
                onOptionSelect={(_, data) => updateState("userGroupId", data.optionValue)}
                className="input-layout shadow-sm border rounded py-1 px-2 text-sm text-gray-700 w-full"
              // disabled={!userGroups.length}
              >
                <Option value="">Select</Option>
                {userGroups?.map((ug) => (
                  <Option key={ug.userGroupID} value={String(ug.userGroupID)}>
                    {ug.description}
                  </Option>
                ))}
              </Dropdown>
            </Field>
            </div>
               <div className="flex w-full flex-row items-center">
          <label  style={{ minWidth: '8rem' }} className="h3-text text-left block text-gray-600 text-xs sm:text-sm lg:text-base font-medium mb-1 w-30">User</label>
            <Field className="items-center  gap-1 w-full">
              <Dropdown
                aria-label="User"
                size="small"
                positioning={{ autoSize: false }}
                listbox={{ style: { maxHeight: "min(18rem, 60vh)", overflowY: "auto" } }}
                style={{ minWidth: 0, width: "100%" }}
                value={user?.find((item) => String(item.userID) === String(taskPaneState.userGroup))?.userName || "Select"}
                selectedOptions={[String(taskPaneState.userGroup ?? "")]}
                onOptionSelect={(_, data) => {
                   if(taskPaneState.taskQueue) updateState("taskQueue", "");
                   updateState("userGroup", data.optionValue)}
                }
                className="input-layout shadow-sm border rounded py-1 px-2 text-sm text-gray-700 w-full"
                // disabled={!userGroups.length}
                //disabled={!taskPaneState?.taskChecked || !user?.length || !taskPaneState?.userGroupId}
                disabled={!taskPaneState?.taskChecked || !taskPaneState?.userGroupId}

              >
                  <Option value="">Select</Option>
                {user?.map((ug) => (
                  <Option key={ug.userID} value={String(ug.userID)}>
                    {ug.userName}
                  </Option>
                ))}
              </Dropdown>
            </Field>
            </div>


              <div className="flex w-full flex-row items-center">
          <label  style={{ minWidth: '8rem' }} className="h3-text text-left block text-gray-600 text-xs sm:text-sm lg:text-base font-medium mb-1 w-30">Queue</label>
            <Field className="items-center gap-1 w-full" style={{ minWidth: 0, flex: 1 }}>
              <Dropdown
                aria-label="Queue"
                size="small"
                positioning={{ autoSize: false }}
                listbox={{ style: { maxHeight: "min(18rem, 60vh)", overflowY: "auto" } }}
                style={{ minWidth: 0, width: "100%" }}
                value={queues?.find((item) => String(item.imgCommonQueueID) === String(taskPaneState.taskQueue))?.queueName || "Select"}
                selectedOptions={[String(taskPaneState.taskQueue ?? "")]}
                onOptionSelect={(_, data) => {
                  if(taskPaneState.userGroup) updateState("userGroup", "");
                  updateState("taskQueue", data.optionValue);
                }}
                className="input-layout shadow-sm border rounded py-1 px-2 text-sm text-gray-700 w-full"
                // disabled={!queues.length}
               //disabled={!taskPaneState?.taskChecked || !queues?.length || !taskPaneState?.userGroupId}
               disabled={!taskPaneState?.taskChecked || !taskPaneState?.userGroupId}

              >
                  <Option value="">Select</Option>
                {queues.map((qu) => (
                  <Option key={qu.imgCommonQueueID} value={String(qu.imgCommonQueueID)}>
                    {qu.queueName}
                  </Option>
                ))}
              </Dropdown>
            </Field>
            </div>
              <div className="flex w-full flex-row items-center">
          <label style={{ minWidth: '8rem' }} className="h3-text text-left block text-gray-600 text-xs sm:text-sm lg:text-base font-medium mb-1 w-30">Task Type</label>
            <Field className="items-center gap-1 w-full" style={{ minWidth: 0, flex: 1 }}>
              <Dropdown
                aria-label="Task Type"
                size="small"
                positioning={{ autoSize: false }}
                listbox={{ style: { maxHeight: "min(18rem, 60vh)", overflowY: "auto" } }}
                style={{ minWidth: 0, width: "100%", height: "auto" }}
                button={{ style: { whiteSpace: "normal", overflowWrap: "anywhere", textAlign: "left" } }}
                disabled={!taskPaneState?.taskChecked || !taskTypes?.length || !taskPaneState?.userGroupId}
                value={taskTypes.find((item) => String(item.taskTypeId) === String(taskPaneState.taskType))?.description || "Select"}
                selectedOptions={[String(taskPaneState.taskType ?? "")]}
                onOptionSelect={(_, data) => updateState("taskType", data.optionValue)}
                className="input-layout shadow-sm border rounded py-1 px-2 text-sm text-gray-700 w-full"
              >
                <Option value="">Select</Option>
                {taskTypes.map((tt) => (
                  <Option key={tt.taskTypeId} value={String(tt.taskTypeId)}>
                    {tt.description}
                  </Option>
                ))}
              </Dropdown>
            </Field>
            </div>
          </div>
          {/* Note */}
          <div className="grid grid-cols-1 sm:mt-0 lg:mt-0 mt-3 sm:grid-cols-1 lg:grid-cols-1 gap-1">
               <div className="flex flex-row">
          <label  style={{ minWidth: '8rem', marginTop: '6px' }} className="pl:0 sm:pl-8 h3-text text-left block text-gray-600 text-xs sm:text-sm lg:text-base font-medium mb-0 w-30">Note</label>
            <Field className="items-center gap-1 w-full">
              <textarea
                disabled={!taskPaneState?.taskChecked}
                value={taskPaneState.taskNote}
                onChange={(e) => updateState("taskNote", e.target.value)}
                className="shadow-sm border rounded py-1 px-2 text-sm text-gray-700 w-full mb-1 resize-none"
                rows={4}
                style={{ lineHeight: '1.1rem' }}
              />
            </Field>
            </div>
              <div className="flex flex-row items-center">
          <label style={{ minWidth: '8rem' }} className="pl:0 sm:pl-8 h3-text text-left block text-gray-600 text-xs sm:text-sm lg:text-base font-medium mb-1 w-30">Priority</label>
            <Field className="gap-1 w-full" style={{ minWidth: 0 }}>
              <Dropdown
                aria-label="Priority"
                size="small"
                positioning={{ autoSize: false }}
                listbox={{ style: { maxHeight: "min(18rem, 60vh)", overflowY: "auto" } }}
                style={{ minWidth: 0, width: "100%" }}
                disabled={!taskPaneState?.taskChecked}
                value={priorityList?.find((item) => String(item.priorityId) === String(taskPaneState.taskPriority))?.priorityDescription || "Select"}
                selectedOptions={[String(taskPaneState.taskPriority ?? "")]}
                onOptionSelect={(_, data) => updateState("taskPriority", data.optionValue)}
                    className="input-layout shadow-sm border rounded py-1 px-2 text-sm w-full"
              >
                  <Option value="">Select</Option>
                {priorityList?.map((ug) => (
                  <Option key={ug.priorityId} value={String(ug.priorityId)}>
                    {ug.priorityDescription}
                  </Option>
                ))}
              </Dropdown>
            </Field>
              </div>
            </div>
      </div>

<div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-2 gap-1 mt-1">
            {/* Due Date */}
               <div className="flex flex-row items-center">
          <label style={{ minWidth: '8rem' }} className="h3-text text-left block text-gray-600 text-xs sm:text-sm lg:text-base font-medium mb-1 w-30">Due Date </label>
           <Field className="items-center gap-1 w-full">
            <input
              disabled={!taskPaneState?.taskChecked}
              min="1900-01-01"
              type="date"
              value={taskPaneState.taskDueDate}
              onChange={(e) => updateState("taskDueDate", e.target.value)}
              className="input-layout shadow-sm border rounded py-1 px-2 text-sm text-gray-700 w-full"
            />
          </Field>
          </div>
          {/* Start Date */}
               <div className="flex flex-row items-center">
          <label style={{ minWidth: '8rem' }} className="pl:0 sm:pl-8 h3-text text-left block text-gray-600 text-xs sm:text-sm lg:text-base font-medium mb-1 w-30">Start Date </label>
           <Field className="items-center gap-1 w-full">
            <input
              disabled={!taskPaneState?.taskChecked}
              min="1900-01-01"
              type="date"
              value={taskPaneState.taskStartDate}
              onChange={(e) => updateState("taskStartDate", e.target.value)}
               className="input-layout shadow-sm border rounded py-1 px-2 text-sm text-gray-700 w-full"
            />
          </Field>
          </div>
               <div className="flex flex-row items-center">
          <label style={{ minWidth: '8rem' }} className="h3-text text-left block text-gray-600 text-xs sm:text-sm lg:text-base font-medium mb-1 w-30">Add # of days </label>
            <Field className="items-center gap-2 w-full">
            <input
              // disabled={!taskPaneState?.taskChecked}
              ref={inputRefDue}
              type="text"
              onKeyPress={handleKeyNumberPress}
              placeholder="+days"
              value={dueDaysToAdd}
              onChange={(e) => setDueDaysToAdd(e.target.value)}
              className="input-layout shadow-sm border rounded py-1 px-2 text-sm text-gray-700 w-full"
            />
          </Field>
          </div>
               <div className="flex flex-row items-center">
          <label style={{ minWidth: '8rem' }} className="pl:0 sm:pl-8 h3-text text-left block text-gray-600 text-xs sm:text-sm lg:text-base font-medium mb-1 w-30">Add # of days </label>
            <Field className="items-center gap-2 w-full">
            <input
              ref={inputRef}
              // disabled={!taskPaneState?.taskChecked}
              onKeyPress={handleKeyNumberPress}
              placeholder="+days"
              value={startDaysToAdd}
              onChange={(e) => setStartDaysToAdd(e.target.value)}
              className="input-layout shadow-sm border rounded py-1 px-2 text-sm text-gray-700 w-full"
            />
          </Field>
          </div>
</div>
          <div className="flex justify-end mt-1">
        <Button
            disabled={!((startDaysToAdd) || (dueDaysToAdd))}
            onClick={handleApplyDays}
            className={`${(!((startDaysToAdd) || (dueDaysToAdd)))? "btn-com-disable": "btn-com"}`}
          >
            Apply
          </Button>
            </div>
</>}
    </>
  );
};

export default TaskForm;
